import { container, singleton } from "tsyringe";
import SubscriptionPlanApi from "api/clapaction/SubscriptionPlanApi";
import SubscriptionPlanResponseResource from "common/resources/SubscriptionPlan/SubscriptionPlanResponseResource";

@singleton()
export default class SubscriptionPlanService {
	private api: SubscriptionPlanApi = container.resolve(SubscriptionPlanApi);

	public async getSubscriptionPlan(userId: string): Promise<SubscriptionPlanResponseResource | null> {
		return this.api.getSubscriptionPlan(userId).catch(() => null);
	}
}
